import React from 'react';
import { twJoin } from 'tailwind-merge';

export type TrackingStatusItemProps = {
  Icon: React.FC;
  label: string;
  isActive: boolean;
  className?: string;
};

export default function TrackingStatusItem({
  Icon,
  label,
  isActive,
  className = '',
}: Readonly<TrackingStatusItemProps>) {
  return (
    <div
      className={twJoin(
        'z-10 flex items-center gap-3 sm:flex-col',
        isActive && 'text-neutral-100',
        className,
      )}
    >
      <div className="rounded-full bg-white sm:p-3">
        <Icon />
      </div>
      <span>{label}</span>
    </div>
  );
}
